"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@uirouter/react");
var react_redux_1 = require("react-redux");
var React = require("react");
var react_2 = require("react");
var core_1 = require("../core");
function ConnectedUIRouter(_a) {
    var children = _a.children, routerFromProps = _a.router, plugins = _a.plugins, config = _a.config, states = _a.states;
    var init = react_2.useRef(false);
    var store = react_2.useContext(react_redux_1.ReactReduxContext).store;
    var router = react_2.useRef(routerFromProps);
    var reduxPlugin = react_2.useRef(core_1.createReduxPlugin(store));
    // let's initialise the plugins and set up the router
    if (init.current !== true) {
        // services plugin is necessary for UIRouter to function
        router.current.plugin(react_1.servicesPlugin);
        // apply all the plugins that are passed via props
        plugins.forEach(function (plugin) { return router.current.plugin(plugin); });
        // apply the newly created redux plugin
        router.current.plugin(reduxPlugin.current);
        if (config)
            config(router.current);
        (states || []).forEach(function (state) {
            return router.current.stateRegistry.register(state);
        });
        init.current = true;
    }
    return React.createElement(react_1.UIRouter, { router: router.current }, children);
}
exports.ConnectedUIRouter = ConnectedUIRouter;
//# sourceMappingURL=ConnectedUIRouter.js.map